/**
 * Created by mukund on 7/17/15.
 */

'use strict';

angular.module('mediacloudApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('reindex', {
                parent: 'site',
                url: '/administration/reindex',
                params: {collectionId : null},
                data: {
                    roles: [],
                    pageTitle: 'playback-analytics.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/administration/reindex/templates/reindex.html',
                        controller: 'ReindexController'
                    }
                },

                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('playback-analytics');
                        return $translate.refresh();
                    }]
                }
            });
    });
